import React from 'react';
import FavouriteList from './favouriteList';

const Favourites = (props) => {
    return (
        <div>
            <FavouriteList {...props}></FavouriteList>
        </div>
    );
};

export default Favourites;